// @LTG-ID: data-sample-report
// @STATUS: BUILT @SHARED
// @HERMETIC: true
// @DOCS: 08_FEATURES.md#F-014, 11_OPEN_QUESTIONS.md#OQ-009
// @CHANGED: 2026-02 session_003 (CHG-0043)
// @OWNER: web
//
// =============================================================================
// EDITORIAL REVIEW REQUIRED BEFORE PRODUCTION DEPLOY
// =============================================================================
// The fictional business names rendered in SampleReport's cover page come from
// `data/sectors.js` (the `example` field per sector). They are intentional
// regional placeholders for the Charlotte / NC market and are chosen for
// credibility flavor only.
//
// Names are fictional and chosen for regional credibility (NC market). Replace
// before launch if any name unintentionally resembles a real KGOB client —
// confirm with Sara before production deploy.
//
// Tracked as OQ-009 in /app/docs/11_OPEN_QUESTIONS.md.
// =============================================================================
//
// The numbers below (indicative-value range, three scores, three priority moves)
// are illustrative DEFAULTS for the static sample preview. They are NOT computed
// from any sector — every visitor sees the same sample numbers. Only the
// business NAME re-skins with the selected sector.

export const SAMPLE_REPORT = {
    indicativeValue: "$3.2M to $4.1M",
    scores: [
        { label: "Strategic Score", value: 62 },
        { label: "Exit Score", value: 48 },
        { label: "Freedom Score", value: 71 },
    ],
    // Single bar visualizes Strategic Score per source line 2304
    progressFillPct: 62,
    priorityMoves: [
        "De-concentrate top customer below 25% of revenue",
        "Build a recurring-revenue service tier",
        "Hire a second-in-command before any LOI",
    ],
    pageMeta: {
        methodologyLine:
            "Prepared by the Let's Talk Growth methodology",
        signatureLine: "Methodology by Sara F. Gonzalez, CPA · NC CPA #30420",
    },
    signature: {
        scriptName: "Sara F. Gonzalez",
        metaLines: [
            "Sara F. Gonzalez, CPA",
            "Managing Partner, KGOB CPAs & Advisors",
            "NC CPA license #30420",
        ],
        disclaimer:
            "Indicative valuation only. Not a USPAP-compliant business appraisal under SSVS No. 1. For SSVS-compliant valuation, gift / estate, ESOP, or litigation engagements, contact KGOB at (704) 599-3355.",
    },
    fineprint:
        "Pages above are stylized previews. Actual Snapshot includes Sector Benchmarks, the 10-Lever Detail, the 60-Month Projection, and the Tax-Efficiency Review.",
};

// Default business name when no sector selected. Matches source line 2265
// (`sector ? getSector(sector).example : 'Your business'`).
export const DEFAULT_BUSINESS_NAME = "Your business";
